import { ReactElement } from 'react';
import { TMarket, TPlan } from '@/common/constants/markets';
import { ROUTES } from '@/common/constants/routes';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { Redirect } from 'expo-router';

export type TRouterGuardOptions = {
  market?: TMarket[];
  plan?: TPlan[];
};

export function WithRouterGuard(
  component: ReactElement,
  options: TRouterGuardOptions
) {
  const { company } = useEmployeeDetails();

  if (
    (options.market && !options.market.includes(company.market.slug)) ||
    (options.plan && !options.plan.includes(company.settings.plan))
  ) {
    return <Redirect href={ROUTES.NOT_FOUND} />;
  }
  return component;
}

export function useRouteMarketGuard(options: TRouterGuardOptions) {
  const { company } = useEmployeeDetails();

  if (
    (options.market && !options.market.includes(company.market.slug)) ||
    (options.plan && !options.plan.includes(company.settings.plan))
  ) {
    return <Redirect href={ROUTES.NOT_FOUND} />;
  }
}
